"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JovianMultiplier = void 0;
var vue_1 = require("vue");
exports.JovianMultiplier = vue_1.default.component('JovianMultiplier', {
    props: {
        amount: {
            type: Number,
        },
    },
    methods: {},
    template: "\n    <div class=\"player-jovian-multiplier\" style=\"font-size:13px\">{{ amount }}</div>\n  ",
});
//# sourceMappingURL=JovianMultiplier.js.map